import React from "react";
import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Typography,
} from "@mui/material";
import { fetchPodcastTypes, PodcastType } from "../../services/api";

const PodcastTypeList: React.FC = () => {
  const {
    data: podcastTypes,
    isLoading,
    error,
  } = useQuery<PodcastType[]>({
    queryKey: ["podcastTypes"],
    queryFn: fetchPodcastTypes,
  });

  if (isLoading) return <Typography>Loading...</Typography>;
  if (error) return <Typography>An error has occurred</Typography>;

  return (
    <>
      <Typography variant="h4" gutterBottom>
        Podcast Types
      </Typography>
      <Button
        component={Link}
        to="/podcast-types/new"
        variant="contained"
        color="primary"
        sx={{ mb: 2 }}
      >
        Add New Podcast Type
      </Button>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Title</TableCell>
              <TableCell>Description</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {podcastTypes &&
              podcastTypes.map((podcastType: PodcastType) => (
                <TableRow key={podcastType.id}>
                  <TableCell>{podcastType.title}</TableCell>
                  <TableCell>{podcastType.description}</TableCell>
                  <TableCell>
                    {podcastType.active ? "Active" : "Inactive"}
                  </TableCell>
                  <TableCell>
                    <Button
                      component={Link}
                      to={`/podcast-types/edit/${podcastType.id}`}
                      variant="outlined"
                      size="small"
                    >
                      Edit
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default PodcastTypeList;
